import React from 'react';
import ButtonsGeneric from '../ButtonsGeneric';
import InputText from '../InputText';
import { TableCalcStyle, WrapperTables } from '../TableCalcCompStyle';

export default function TableCalcCompRacOutAli() {
  return (
    <WrapperTables>
      <TableCalcStyle>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome dos Profissionais</th>
            <th>Tipo</th>
            <th>Qtd Refeições</th>
            <th>Valor Un. de Ref.</th>
            <th>Valor Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>
              <InputText title="" id="NomeDosProfissionais1" widthPercentage="95%" />
            </td>
            <td>
              <InputText title="" id="Tipo1" widthPercentage="95%" />
            </td>
            <td>
              <InputText title="" id="QtdRefeicoes1" widthPercentage="95%" />
            </td>
            <td>
              <InputText title="" id="ValorUnDeRef1" widthPercentage="95%" />
            </td>
            <td>
              <p>R$ 0,00</p>
            </td>
          </tr>
        </tbody>
      </TableCalcStyle>
      <ButtonsGeneric>
        <button className="success">+ Adicionar</button>
      </ButtonsGeneric>
    </WrapperTables>
  );
}
